/* The real customer logos, taken from the live landing page.

   One list, used by both the revolving strip (Trusted.jsx) and the logo wall
   (Power.jsx). They used to be two separate sets of invented brands, which is
   how they drifted apart and how one of them silently broke. */

export const LOGOS = [
  { src: '/assets/logos/Brand_gridd.webp', alt: 'BrandGrid' },
  { src: '/assets/logos/saeller_777.webp', alt: 'Seller 7' },
  { src: '/assets/logos/ecomsellertoollogo_.webp', alt: 'Ecomsellertool' },
  { src: '/assets/logos/Cord4_11111.webp', alt: 'CORD4' },
  { src: '/assets/logos/grow8_1.webp', alt: 'Grow8' },
];

export default LOGOS;
